import axios from 'axios'
import { Message } from 'element-ui';
import Vue from 'vue'
import router from './../router';

const service = axios.create({
    // baseURL: 'http://masteel.org.cn/centerapi',//钢铁一级节点门户正式打包，接口地址 2024.11.20
    //  baseURL: 'http://59.110.138.73:8081/centerapi',//钢铁一级节点门户正式打包，接口地址 2024.11.20
    baseURL: '/centerapi',//中国食品工业
    timeout: 30000,// 超时时间 单位是ms，这里设置了30s的超时时间
})
// 门户的  
// 一级节点  /api
// 请求拦截
service.interceptors.request.use(config => {
    if (config.params) {
      config.params._t = Date.now()
    }
    return config
},error => {
    return Promise.reject(error)
})

// 响应拦截
service.interceptors.response.use(response => {
    const res = response.data
    // console.log('响应拦截')
    // console.log(JSON.parse(JSON.stringify(res)))
    if (res.errno == 0) {
        return res
    }else if(res.errno == 501){//未登录
        // Message({
        //     message: res.errmsg,
        //     type: 'error',
        //     duration: 2000,
        //     onClose:()=>{
        //         router.push({
        //             path: '/login',
        //         })
        //     }
        // })
    }else{
        Message({
            message: res.errmsg,
            type: 'error',
            duration: 2000
        })
        return Promise.reject(res.errmsg)
    }
},error => {
    Message({
        message: res.errmsg,
        type: 'error',
        duration: 2000
    })
    return Promise.reject(error)
})
export const request =opt=>{   
    return new Promise((resolve,reject) =>{        
        service.request(opt).then(res=>{
            resolve(res)
        }).catch(err=>{
            reject(err)
        })
    });
}